import React from 'react';
import { motion } from 'framer-motion';
import { Target, Search, Users, CheckCircle, HeartHandshake } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Target className="w-6 h-6" data-id="element-144" />,
    title: 'Discovery & Role Alignment',
    time: 'Day 1',
    desc: 'We dive deep into your business needs, culture, and the specific requirements of the role.'
  }, {
    icon: <Search className="w-6 h-6" data-id="element-145" />,
    title: 'Talent Search & Evaluation',
    time: 'Days 2–7',
    desc: 'Our team sources and rigorously screens candidates for skills, English proficiency, and cultural fit.'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-146" />,
    title: 'Curated Candidate Shortlist',
    time: 'Days 5–10',
    desc: 'You receive a curated list of top-tier candidates, complete with profiles and our assessment notes.'
  }, {
    icon: <CheckCircle className="w-6 h-6" data-id="element-147" />,
    title: 'Interview, Select & Hire',
    time: 'Weeks 2–3',
    desc: 'You interview the finalists. Once you choose the perfect fit, we help facilitate the offer.'
  }, {
    icon: <HeartHandshake className="w-6 h-6" data-id="element-148" />,
    title: 'Onboarding & Ongoing Support',
    time: 'First 30–90 Days',
    desc: 'We ensure a smooth transition and check in regularly to guarantee long-term success.'
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-149">
      <div className="max-w-7xl mx-auto px-6" data-id="element-150">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-151">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6 text-navy" data-id="element-152">
            From Talent Need to Confident Hire in{' '}
            <span className="text-gradient" data-id="element-153">2–3 Weeks</span>
          </motion.h2>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-154">
          {/* Vertical Line for Desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 -translate-x-1/2 bg-slate-100 rounded-full overflow-hidden" data-id="element-155">
            <motion.div className="absolute top-0 left-0 right-0 bg-brand-gradient" initial={{
            height: '0%'
          }} whileInView={{
            height: '100%'
          }} viewport={{
            once: true,
            margin: '-20%'
          }} transition={{
            duration: 2,
            ease: 'easeInOut'
          }} data-id="element-156" />
          </div>

          <div className="space-y-12 md:space-y-0 relative" data-id="element-157">
            {steps.map((step, index) => {
            const isEven = index % 2 === 0;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-10%'
            }} transition={{
              duration: 0.6,
              delay: index * 0.2
            }} className={`relative flex flex-col md:flex-row items-center ${isEven ? 'md:flex-row-reverse' : ''} md:h-48`} data-id="element-158">
                  {/* Timeline Node */}
                  <div className="absolute left-0 md:left-1/2 top-0 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 w-12 h-12 rounded-full bg-white border-4 border-slate-100 shadow-sm z-10 flex items-center justify-center hidden md:flex" data-id="element-159">
                    <div className="w-4 h-4 rounded-full bg-brand-gradient" data-id="element-160" />
                  </div>

                  {/* Content Card */}
                  <div className={`w-full md:w-1/2 ${isEven ? 'md:pl-16' : 'md:pr-16'} pl-12 md:pl-0`} data-id="element-161">
                    <div className="bg-white p-6 rounded-3xl shadow-soft border border-slate-100 hover:shadow-soft-lg transition-shadow relative group" data-id="element-162">
                      {/* Mobile Timeline Line */}
                      <div className="absolute left-[-2rem] top-8 bottom-[-3rem] w-0.5 bg-slate-100 md:hidden last:bottom-0" data-id="element-163" />
                      <div className="absolute left-[-2.5rem] top-6 w-4 h-4 rounded-full bg-brand-gradient md:hidden z-10" data-id="element-164" />

                      <div className="flex items-center gap-4 mb-4" data-id="element-165">
                        <div className="w-10 h-10 rounded-xl bg-brand-gradient-soft flex items-center justify-center text-purple" data-id="element-166">
                          {step.icon}
                        </div>
                        <div data-id="element-167">
                          <div className="text-sm font-bold text-coral uppercase tracking-wider" data-id="element-168">
                            {step.time}
                          </div>
                          <h3 className="text-lg font-bold text-navy" data-id="element-169">
                            {step.title}
                          </h3>
                        </div>
                      </div>
                      <p className="text-slate-600" data-id="element-170">{step.desc}</p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}